import fetchV2 from "auth/FetchInterceptorV2";
import { env } from "configs/EnvironmentConfig";

const leadTimeService = {};

// Create Shipping Unit
leadTimeService.createLeadTime = data => {
  return fetchV2({
    url: `${env.API_MSP}/lead-times`,
    method: "post",
    data: {
      ...data,
    },
  });
};
leadTimeService.updateLeadTime = ({ id, ...data }) => {
  return fetchV2({
    url: `${env.API_MSP}/lead-times/${id}`,
    method: "put",
    data: {
      ...data,
    },
  });
};
leadTimeService.deleteLeadTime = ({ id }) => {
  return fetchV2({
    url: `${env.API_MSP}/lead-times/${id}`,
    method: "delete",
  });
};
leadTimeService.geListLeadTime = ({ params }) => {
  return fetchV2({
    url: `${env.API_MSP}/lead-times`,
    method: "get",
    params: {
      ...params,
      "filter[record_status]": "O",
    },
  });
};

export default leadTimeService;
